var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container",attrs:{"id":"loading-bg"}},[_c('div',{staticClass:"svg-container"},[_c('DecastAnimatedLogo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }